<div [ngSwitch]="centralId">
  <!-- Renderiza o componente CivicsComponent se centralId for 'civics' -->
  <app-civics *ngSwitchCase="'civics'"></app-civics>
  <app-civics-v2 *ngSwitchCase="'civics-v2'"></app-civics-v2>
  <app-seguros-pf *ngSwitchCase="'seguros-pf'"></app-seguros-pf>
  <app-pessoa-juridica *ngSwitchCase="'pj'"></app-pessoa-juridica>
  <app-npc *ngSwitchCase="'npc'"></app-npc>
  <app-corretora *ngSwitchCase="'corretora'"></app-corretora>
  <app-pessoa-fisica *ngSwitchCase="'pf'"></app-pessoa-fisica>
  <app-gerente-pf *ngSwitchCase="'gerentes-pf'"></app-gerente-pf>
  <app-itau-shop *ngSwitchCase="'itau-shop'"></app-itau-shop>
  <app-idp-callback *ngSwitchCase="'idp-callback'"></app-idp-callback>
  <app-consultores-seguros-pf
    *ngSwitchCase="'consultores-seguros-pf'"
  ></app-consultores-seguros-pf>
  <app-rede-pj *ngSwitchCase="'rede-pj'" />
  <app-ibba *ngSwitchCase="'ibba'" />
  <app-recuperacao *ngSwitchCase="'recuperacao'" />
  <app-ouvidoria *ngSwitchCase="'ouvidoria'" />

  <!-- Renderiza um fallback caso centralId não corresponda a nenhum caso -->
  <div *ngSwitchDefault>
    <p>Componente não encontrado para o valor de centralId: {{ centralId }}</p>
  </div>
</div>
